if (!customElements.get("recently-viewed")) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();

      this.productHandle = null;
      this.productLimit = null;
    }

    connectedCallback() {
      // Timeout wrapper for Firefox bug
      setTimeout(() => {
        if (typeof Cookie == null) return;

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.productHandle = this.dataset.productHandle;
          this.productLimit = this.dataset.productLimit;
          this.setRecentlyViewedProducts();
        };

        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 200px 0px",
        }).observe(this);
      }, 0);
    }

    setRecentlyViewedProducts() {
      const productsHandle = this.getProductsHandle(this.productHandle);
      let productsHandleArray = [];
      if (productsHandle) {
        productsHandleArray = decodeURI(productsHandle).split(",");
      }

      let productsToRender = productsHandleArray;

      if (this.productHandle) {
        if (productsHandleArray.includes(this.productHandle)) {
          productsToRender = productsHandleArray.filter((handle) => {
            return handle !== this.productHandle;
          });
        } else {
          let newHandles = [this.productHandle].concat(productsHandleArray);
          this.setCookieProducts(newHandles);
        }
      }

      if (productsToRender.length > 0) {
        this.renderProducts(productsToRender);
      }
    }

    getProductsHandle(productHandle) {
      let productsHandle = Cookies.get("recentlyViewed");
      if (!productsHandle && productHandle) {
        Cookies.set("recentlyViewed", productHandle, {
          expires: 30,
          path: "/",
        });
        productsHandle = Cookies.get("recentlyViewed");
      }
      return productsHandle;
    }

    renderProducts(productsToRender) {
      if (this.productLimit && productsToRender) {
        productsToRender = productsToRender.slice(0, this.productLimit);
      }
      let productWrapper = this.querySelector("[data-products-wrapper]");
      const fetchPromises = [];
      productsToRender.forEach((value) => {
        const fetchPromise = fetch("/products/" + value + "?view=rv")
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const productCard = html.querySelector(".td-recently-viewed__item");

            if (productCard && productCard.innerHTML.trim().length) {
              productWrapper.append(productCard);
            }
          })
          .catch((e) => {
            console.error(e);
          });

        fetchPromises.push(fetchPromise);
      });

      this.classList.add("td-recently-viewed__initialized");

      Promise.all(fetchPromises).then(() => {
        const renderedCount = this.querySelectorAll(".td-recently-viewed__item").length;
        this.classList.add(`products-rendered-${renderedCount}`);
        const swiper = this.querySelector(".swiper-slider-container");
        const recentlyViewedRendered = new Event('recently-viewed-initialized');
        swiper.dispatchEvent(recentlyViewedRendered);
      });
    }

    setCookieProducts(productsHandleArray) {
      Cookies.set("recentlyViewed", decodeURI(productsHandleArray.join(",")), {
        expires: 30,
        path: "/",
      });
    }
  }
  customElements.define("recently-viewed", RecentlyViewed);
}